import React from 'react'
import { observer } from 'mobx-react'
import styles from './DocumentCreationModal.sass'
import { DocumentCreationModalViewModel } from './DocumentCreationModalViewModel'
import {
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheet,
  ModalSheetHeaderCloseButton,
  ModalSheetHeaderShell,
  ModalSheetContent,
} from 'components/ModalSheet'
import Button from 'components/Button'
import { DocumentCreationItem } from './DocumentCreationItem'
import DragAndDropOverlay from 'jobs/views/JobRoot/Job/DragAndDropOverlay'
import { useDropzone } from 'hooks/use-dropzone'
import FileButton from 'components/FileButton'

interface Props {
  vm: DocumentCreationModalViewModel
}

export default observer(function DocumentCreationModal({ vm }: Props) {
  function onDrop(files: FileList) {
    vm.addFiles(files)
  }

  function onEnter() {
    vm.setDragging()
  }

  function onLeave() {
    vm.stopDragging()
  }

  const [, dropZoneRef] = useDropzone<HTMLDivElement>(onDrop, onEnter, onLeave)
  return (
    <ModalSheet
      ref={dropZoneRef}
      showing={vm.showing}
      disableCloseOnOutsideClick={true}
      onRequestClose={vm.close}
    >
      <DragAndDropOverlay vm={vm.uploadBarVM} targetJob={vm.job} />
      <ModalSheetHeaderShell size="auto" bordered>
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <div className={styles.headerInfo}>
              <div className={styles.headerTitle}>
                <span>Assign file type</span>
              </div>
              <div className={styles.headerDescription}>
                <span>Select an appropriate document type for each file</span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.closeBtn}>
          <ModalSheetHeaderCloseButton onClick={vm.close} />
        </div>
      </ModalSheetHeaderShell>
      <ModalSheetContent>
        <div className={styles.creationItemList}>
          {vm.documentCreationItemVMs.map((docCreationItemVM, index) => (
            <div key={index}>
              <DocumentCreationItem
                index={index}
                vm={docCreationItemVM}
                removeFile={vm.removeFile}
              />
            </div>
          ))}
          <div
            className={
              vm.dragging ? styles.dropZoneItemDragging : styles.dropZoneItem
            }
          >
            <span className={styles.dropZoneTitle}>
              Drag and drop files here or&nbsp;
              <FileButton multiple onChange={vm.addFiles}>
                <Button
                  className={styles.dropZoneButton}
                  borderless
                  type="text"
                >
                  Upload another file
                </Button>
              </FileButton>
            </span>
          </div>
        </div>
      </ModalSheetContent>
      <ModalSheetFooter>
        <div className={styles.footer}>
          <div className={styles.uploadButton}>
            <ModalSheetFooterButtonGroup>
              <Button
                type="primary"
                disabled={
                  vm.typesSelected < vm.documentCreationItemVMs.length ||
                  !vm.documentCreationItemVMs.length
                }
                onClick={async () => {
                  const success = await vm.uploadFiles()
                  if (success) {
                    vm.close()
                  }
                }}
              >
                Upload Documents
              </Button>
            </ModalSheetFooterButtonGroup>
          </div>
        </div>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
